import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const DEPARTMENT_UPDATE_RESOURCE = "department" as const;
export const DEPARTMENT_UPDATE_API_PATH = `/v1/${DEPARTMENT_UPDATE_RESOURCE}/{uuid}` as const;

export type DepartmentUpdateBody =
  paths[typeof DEPARTMENT_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type DepartmentUpdateResponse =
  paths[typeof DEPARTMENT_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useDepartmentUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<DepartmentUpdateResponse, Error, DepartmentUpdateBody & { uuid: string }>({
    mutationFn: async (department: DepartmentUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = department;
      const response = await alphartisApiAxios.patch<DepartmentUpdateResponse>(
        `/v1/${DEPARTMENT_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [DEPARTMENT_UPDATE_RESOURCE],
      });
    },
  });
};
